{
  "currencySign": {
    "euro": "€",
    "dollar": "$"
  },
  "step_3_title": "Summary",
  "network_address_placeholder": "Allowed networks (i.e., 10.0.0.4/16)",
  "labels": {
    "date_picker_tooltip": "Please select a cluster and enter the restore point in {{utc}}",
    "date_picker_tooltip_of_selected_cluster": "Enter the restore point in {{utc}}. The oldest possible restore time is {{date}} ({{utc}})",
    "compute_plan": "Compute plan",
    "storage_plan": "Storage plan",
    "cores": "Cores",
    "type": "Type",
    "memory": "Memory",
    "per_day": "per Day",
    "per_month": "per Month",
    "size": "Size",
    "per_instance": "Per Instance",
    "replicas": "Replicas",
    "total": "Total",
    "name": "Name",
    "description": "Description",
    "project": "Project",
    "allow_all_connection": "Allow all connection",
    "recommended": "Recommended",
    "choose_compute_plan": "Choose a compute plan",
    "choose_storage_plan": "Choose a storage plan",
    "select_project": "Select Project",
    "cancel": "Cancel",
    "select_organization_from_left": "Select an organization",
    "select_project_from_left": "Select a project",
    "organizations": "Organizations",
    "departments": "Departments",
    "projects": "Projects",
    "clusters": "Clusters",
    "services": "Services",
    "org_does_not_have_projects": "This organization does not have any projects",
    "project_does_not_have_clusters": "This project does not have any clusters",
    "organization": "Organization",
    "private": "Private",
    "warn_inaccessible_instance": "By supplying no source range, you will not be able to connect to the cluster",
    "unexpected_error": "Unexpected error",
    "select_project_modal_title": "Select a Project",
    "this_cluster_belongs_to": "This cluster belongs to",
    "clone_settings": "Clone settings",
    "backup_datetime": "Select backup Date & Time",
    "source_cluster_belongs_to": "Source cluster belongs to",
    "select_cluster": "Select Cluster",
    "select_cluster_modal_title": "Select a Cluster",
    "select_backup_cluster_modal_title": "Select backup cluster",
    "org_does_not_have_suitable_clusters": "At the moment you do not have organizations with suitable clusters",
    "project_does_not_have_suitable_clusters": "At the moment you do not have projects with suitable clusters",
    "local_time": "Your Local Time",
    "support_plan": "Support plan",
    "choose_support_plans": "Choose a support plan",
    "dynamic_allocation": {
      "cpu_number": "Number of CPUs",
      "memory_gbs": "Memory Capacity",
      "storage_gbs": "Storage Capacity",
      "storage_class": "Storage Class",
      "per_unit": "per Unit",
      "per_gb": "per Gb.",
      "tbs": "{{count}} TBs",
      "use_tbs": "Use TBs for Storage",
      "storage": "Storage: ",
      "memory": "Memory: "
    },
    "mode": {
      "switch_to_plan": "Switch to Assistant mode",
      "switch_to_dynamic": "Switch to Advanced mode"
    },
    "configure_maintenance_windows": {
      "weekday": "Select maintenance day",
      "every_day": "Daily",
      "start_time": "Start time",
      "end_time": "End time",
      "max_limit": "Maximum number of maintenance windows reached",
      "local_time_hint": "Scheduled maintenance is <b>{{weekday}}</b> from <b>{{startTime}}</b> to <b>{{endTime}}</b> ({{utcLocal}}, your local time)",
      "actions": {
        "add": "Add maintenance window",
        "remove": "Remove maintenance window"
      }
    }
  },
  "templates": {
    "create_cluster": "Create {{name}}",
    "create_cluster_from_backup": "Create {{name}} from backup",
    "add_to_project": "Add to {{project}}",
    "select_entity": "Select {{name}}"
  },
  "parameters": {
    "configure_backup": "Backup configuration",
    "clone_acl": "Access control list (pg_hba)",
    "clone_parameters": "PostgreSQL parameters",
    "clone_logical_backup_configuration": "Logical backups",
    "clone_continuous_backup_configuration": "Continuous backups",
    "configure_maintenance_windows": "Maintenance windows configure"
  },
  "specs": {
    "price_with_sign": "{{amount|currency}}",
    "memory_in_gb": "{{count}} GB",
    "size_in_gb": "{{count}} GB",
    "cores_spec": "{{count}} Core",
    "cores_spec_plural": "{{count}} Cores",
    "none": "None"
  },
  "buttons": {
    "previous": "Previous",
    "next": "Next",
    "create": "Create",
    "reset_backup_config": "Reset to source cluster's configuration"
  },
  "validation": {
    "name": {
      "empty": "Name is required",
      "duplicate_name": "Cluster with same name already exists",
      "min_length": "Min length of name is {{minLength}} characters",
      "max_length": "Max length of name is {{maxLength}} characters",
      "invalid": "Name should begin with a letter and end with a letter or digit. May include spaces, dots and dashes."
    },
    "description": {
      "required": "Description is required",
      "max": "Max length of description is 200 characters"
    },
    "project": {
      "required": "Project is required"
    },
    "allowedSourceRanges": {
      "not_valid": "Invalid network address (valid format: 10.0.0.4/16)"
    },
    "allowedSourceRangesInput": {
      "not_valid": "Invalid network address (valid format: 10.0.0.4/16)"
    },
    "backupTimestamp": {
      "empty": "Backup Datetime is required",
      "after_max_date": "Backup Datetime should not be after {{maxDate}} ({{utc}})",
      "before_min_date": "Backup Datetime should not be before {{minDate}} ({{utc}})",
      "invalid_date": "Invalid date format",
      "invalid_date_label": "Invalid date"
    },
    "backupCluster": {
      "empty": "Cluster is required"
    },
    "backupName": {
      "insufficient_storage_space": "The backup size exceeds the available storage space"
    },
    "network_mask_hint": "This is a multi-value field. Please press enter to submit the value.",
    "storageGbs": {
      "empty": "Storage capacity is required",
      "min_capacity": "The minimum storage capacity is {{capacity}}",
      "max_capacity": "The maximum storage capacity is {{capacity}}"
    },
    "memoryGbs": {
      "empty": "Memory capacity is required",
      "min_capacity": "The minimum memory capacity is {{capacity}}",
      "max_capacity": "The maximum memory capacity is {{capacity}}"
    },
    "cpuUnits": {
      "empty": "Number of CPUs is required",
      "min_capacity": "The minimum CPUs amount is {{amount}}",
      "max_capacity": "The maximum CPUs amount is {{amount}}",
      "decimal_places": "Number of CPUs support up to 3 decimal places"
    },
    "maintenance_windows": {
      "max_length": "Maintenance windows should contain only {{maxLength}} values",
      "maintenance_windows_daily_exclusive": "A daily maintenance window cannot be combined with other maintenance windows. Please remove the additional entries"
    }
  },
  "warnings": {
    "cluster_creation_disabled": "Cluster creation has been temporarily disabled. We are sorry for any inconveniences.",
    "insufficient_resources": "The server does not have enough resources to create this cluster. Please contact your superuser to extend the allocation, or try it with a smaller compute plan.",
    "choose_compute_plan": "Your cluster does not match any existing compute plan. Please select a new one.",
    "choose_storage_plan": "Your cluster does not match any existing storage plan. Please select a new one"
  }
}
